import { useCallback } from 'react';
import { useConversions } from './useConversions';

export const useUpdateConversion = (options = {}) => {
    const { setConversions } = useConversions();
    const { fieldName } = options;

    return useCallback(
        update => {
            setConversions(prev => {
                const { currentIndex, buttonData } = update;
                const conversion = prev[currentIndex];

                if (!conversion) return prev;

                const newConversions = prev.slice();

                if (buttonData) {
                    newConversions[currentIndex] = {
                        ...conversion,
                        eventName: buttonData.eventName,
                        path: buttonData.path,
                    };
                } else {
                    newConversions[currentIndex] = fieldName
                        ? { ...conversion, [fieldName]: update.value }
                        : { ...conversion, ...update };
                }

                return newConversions;
            });
        },
        [setConversions, fieldName]
    );
};
